var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { getArgFromUrl } from './index';
import { getInfoAsync } from '../utils/hooks';
import { _T } from '../utils/lang';
var requestErrorHandler = null;
var requestUnauthorizedHandler = null;
var INVALID_TOKEN_MESSAGE = 'Token is invalid!';
var UNAUTHORIZED_CODE = 401;
var UNAUTHORIZED_NOTIFY_COOLDOWN_MS = 1000;
var lastUnauthorizedNotifyAt = 0;
var SUCCESS_CODE_LIST = [200, 0];
var SUCCESS_MESSAGE_LIST = ['success', 'ok'];
export var setRequestErrorHandler = function (handler) {
    requestErrorHandler = handler;
};
export var setRequestUnauthorizedHandler = function (handler) {
    requestUnauthorizedHandler = handler;
    lastUnauthorizedNotifyAt = 0;
};
export var buildCommonRequestHeaders = function () {
    var token = getArgFromUrl('token');
    var language = getArgFromUrl('language');
    return {
        H5Token: encodeURIComponent("".concat(token || '')).replace(/%20/g, '%2B'),
        language: "".concat(language || ''),
        ver: '1.0.18',
    };
};
var notifyRequestError = function (message) {
    if (requestErrorHandler) {
        requestErrorHandler(message);
        return;
    }
    console.error(message);
};
var extractResponseMessage = function (responseData) {
    return (responseData === null || responseData === void 0 ? void 0 : responseData.message) || (responseData === null || responseData === void 0 ? void 0 : responseData.msg);
};
var getErrorMessage = function (responseData) {
    return extractResponseMessage(responseData) || _T('error');
};
var normalizeCode = function (code) {
    if (typeof code === 'number') {
        return code;
    }
    if (typeof code === 'string' && code.trim()) {
        var normalizedCode = Number(code);
        return Number.isFinite(normalizedCode) ? normalizedCode : undefined;
    }
    return undefined;
};
var isBusinessSuccessResponse = function (responseData) {
    var normalizedCode = normalizeCode(responseData === null || responseData === void 0 ? void 0 : responseData.code);
    if (normalizedCode != null) {
        return SUCCESS_CODE_LIST.includes(normalizedCode);
    }
    var message = extractResponseMessage(responseData);
    if (!message) {
        return false;
    }
    return SUCCESS_MESSAGE_LIST.includes(message.trim().toLowerCase());
};
var isExplicitBusinessErrorResponse = function (responseData) {
    var normalizedCode = normalizeCode(responseData === null || responseData === void 0 ? void 0 : responseData.code);
    return normalizedCode != null && !SUCCESS_CODE_LIST.includes(normalizedCode);
};
var isUnauthorizedResponse = function (status, responseData) {
    if (status === UNAUTHORIZED_CODE) {
        return true;
    }
    var rawCode = responseData === null || responseData === void 0 ? void 0 : responseData.code;
    var numericCode = typeof rawCode === 'string' ? Number(rawCode) : rawCode;
    if (numericCode === UNAUTHORIZED_CODE) {
        return true;
    }
    return getErrorMessage(responseData) === INVALID_TOKEN_MESSAGE;
};
var notifyUnauthorized = function () {
    if (!requestUnauthorizedHandler) {
        return;
    }
    var now = Date.now();
    if (now - lastUnauthorizedNotifyAt < UNAUTHORIZED_NOTIFY_COOLDOWN_MS) {
        return;
    }
    lastUnauthorizedNotifyAt = now;
    requestUnauthorizedHandler();
};
var RequestApiError = /** @class */ (function (_super) {
    __extends(RequestApiError, _super);
    function RequestApiError(message, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, message) || this;
        _this.name = 'RequestApiError';
        _this.response = options.response;
        _this.request = options.request;
        _this.isUnauthorized = options.isUnauthorized || false;
        _this.logResponse = options.logResponse || false;
        return _this;
    }
    return RequestApiError;
}(Error));
var reactAppEnv;
var nodeEnv;
try {
    reactAppEnv = process.env.REACT_APP_ENV;
    nodeEnv = process.env.NODE_ENV;
}
catch (_a) {
    reactAppEnv = undefined;
    nodeEnv = undefined;
}
var appEnv = (typeof __APP_ENV__ !== 'undefined' ? __APP_ENV__ : undefined) ||
    reactAppEnv ||
    nodeEnv ||
    '';
var normalizedAppEnv = appEnv.toLowerCase();
var isDevLikeEnv = normalizedAppEnv === 'test' ||
    normalizedAppEnv === 'dev' ||
    normalizedAppEnv === 'local' ||
    normalizedAppEnv.startsWith('development');
var fallbackBaseUrl = isDevLikeEnv
    ? 'http://192.168.0.233:9000'
    : 'https://apiv2.danachatapp.com';
var normalizedFallbackBaseUrl = fallbackBaseUrl.replace(/\/$/, '');
var runtimeBaseUrlCache = {};
export var apiBaseURL = "".concat(normalizedFallbackBaseUrl, "/api/v1");
export var resolveApiBaseURL = function () { return __awaiter(void 0, void 0, Promise, function () {
    var dynamicBaseUrl, baseUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (runtimeBaseUrlCache.value) {
                    return [2 /*return*/, "".concat(runtimeBaseUrlCache.value, "/api/v1")];
                }
                return [4 /*yield*/, getInfoAsync('baseUrl')];
            case 1:
                dynamicBaseUrl = _a.sent();
                baseUrl = typeof dynamicBaseUrl === 'string' && dynamicBaseUrl.trim()
                    ? dynamicBaseUrl.trim().replace(/\/$/, '')
                    : normalizedFallbackBaseUrl;
                runtimeBaseUrlCache.value = baseUrl;
                return [2 /*return*/, "".concat(baseUrl, "/api/v1")];
        }
    });
}); };
var axiosInstance = axios.create({
    baseURL: apiBaseURL,
    timeout: 5000,
    headers: buildCommonRequestHeaders(),
});
axiosInstance.interceptors.response.use(function (response) {
    var payload = response.data;
    if (!payload) {
        throw new RequestApiError(_T('error'), { response: response, logResponse: false });
    }
    var message = extractResponseMessage(payload);
    if (isUnauthorizedResponse(response.status, payload)) {
        throw new RequestApiError(message || _T('error'), {
            response: response,
            isUnauthorized: true,
            logResponse: false,
        });
    }
    if (isExplicitBusinessErrorResponse(payload)) {
        throw new RequestApiError(getErrorMessage(payload), { response: response, logResponse: false });
    }
    if (payload.data == null && message && !isBusinessSuccessResponse(payload)) {
        throw new RequestApiError(message, { response: response, logResponse: false });
    }
    return response;
}, function (error) {
    if (error instanceof RequestApiError) {
        return Promise.reject(error);
    }
    var response = error === null || error === void 0 ? void 0 : error.response;
    var responseData = response === null || response === void 0 ? void 0 : response.data;
    var message = getErrorMessage(responseData);
    if (axios.isAxiosError(error)) {
        return Promise.reject(new RequestApiError(message, {
            response: response,
            request: error.request,
            isUnauthorized: isUnauthorizedResponse(response === null || response === void 0 ? void 0 : response.status, responseData),
            logResponse: Boolean(response),
        }));
    }
    return Promise.reject(new RequestApiError(message));
});
function request(method_1, url_1) {
    return __awaiter(this, arguments, Promise, function (method, url, data, config) {
        var runtimeApiBaseURL, requestConfig, response, error_1, errorMessage;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (data === void 0) { data = null; }
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 7, , 8]);
                    return [4 /*yield*/, resolveApiBaseURL()];
                case 1:
                    runtimeApiBaseURL = _k.sent();
                    requestConfig = __assign(__assign({}, config), { baseURL: runtimeApiBaseURL, headers: __assign(__assign({}, buildCommonRequestHeaders()), ((config === null || config === void 0 ? void 0 : config.headers) || {})) });
                    response = void 0;
                    if (!(method === 'GET')) return [3 /*break*/, 3];
                    return [4 /*yield*/, axiosInstance.get(url, requestConfig)];
                case 2:
                    response = _k.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(method === 'POST')) return [3 /*break*/, 5];
                    return [4 /*yield*/, axiosInstance.post(url, data, requestConfig)];
                case 4:
                    response = _k.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error('Unsupported HTTP method');
                case 6: return [2 /*return*/, (_a = response.data) === null || _a === void 0 ? void 0 : _a.data];
                case 7:
                    error_1 = _k.sent();
                    if (error_1 instanceof RequestApiError) {
                        notifyRequestError(error_1.message || _T('error'));
                        if (error_1.isUnauthorized) {
                            notifyUnauthorized();
                        }
                        if (error_1.response && error_1.logResponse) {
                            console.error('Error Response:', error_1.response.data);
                            console.error('Error Status:', error_1.response.status);
                            console.error('Error Headers:', error_1.response.headers);
                        }
                        // Business errors (e.g. code/msg with data:null) should align with old behavior:
                        // notify and return undefined so callers can branch by truthy/falsy result.
                        if (error_1.response && !error_1.logResponse) {
                            return [2 /*return*/, undefined];
                        }
                        if (error_1.response) {
                            throw new Error(error_1.message || 'Request failed');
                        }
                        if (error_1.request) {
                            console.error('Error Request:', error_1.request);
                            throw new Error('No response received from server');
                        }
                        console.error('Error Message:', error_1.message);
                        throw new Error('Request configuration error');
                    }
                    errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        ((_e = (_d = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.msg) ||
                        ((_g = (_f = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.error) ||
                        _T('error');
                    notifyRequestError(errorMessage);
                    if (isUnauthorizedResponse((_h = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _h === void 0 ? void 0 : _h.status, (_j = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _j === void 0 ? void 0 : _j.data)) {
                        notifyUnauthorized();
                    }
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.response) {
                        console.error('Error Response:', error_1.response.data);
                        console.error('Error Status:', error_1.response.status);
                        console.error('Error Headers:', error_1.response.headers);
                        throw new Error(error_1.response.data.message || error_1.response.data.msg || 'Request failed');
                    }
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.request) {
                        console.error('Error Request:', error_1.request);
                        throw new Error('No response received from server');
                    }
                    console.error('Error Message:', error_1 === null || error_1 === void 0 ? void 0 : error_1.message);
                    throw new Error('Request configuration error');
                case 8: return [2 /*return*/];
            }
        });
    });
}
export default request;
